<template>
  <div class="h-8 px-2 flex items-center justify-around border">
    <lm-icon-button
      svg
      svg-size="21"
      icon="remove"
      :disabled="value <= minValue"
      @click="onInput(value - 1)"
    />
    <input
      ref="inputNumber"
      type="number"
      class="NumInput mt-2px text-center w-10"
      :value="value"
      :min="minValue"
      :max="99"
      @input="onInput($event.target.value)"
      @blur="onBlur"
    />
    <lm-icon-button svg svg-size="21" icon="add" @click="onInput(value + 1)" />
  </div>
</template>

<script>
import LmIconButton from '@/components/ui/LmIconButton'
export default {
  name: 'LmInputSpinner',
  components: {LmIconButton},
  props: {
    value: {
      type: Number,
      required: true
    },
    minValue: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {}
  },
  methods: {
    async onInput(value) {
      const n = Number(value) < this.minValue ? this.minValue : Number(value)
      this.$emit('input', n)
      await this.$nextTick()
      this.$refs.inputNumber.focus()
    },
    async onBlur() {
      await this.$nextTick()
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
/* Chrome, Safari, Edge, Opera */
.NumInput::-webkit-outer-spin-button,
.NumInput::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.NumInput[type='number'] {
  -moz-appearance: textfield;
}
</style>
